<template>
  <div id="lemontreeHead" class="head_lemontree" :style="cssProps">
    <button type="button" :class="['btn_snb',{ acitve : getIsActiveGnb }]" @click="$emit('onClickSnb')">
      <span class="icon_hamber">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </span>
    </button>
    <h1 class="tit_logo">
      <router-link class="link_logo" :to="{name:'HOME'}">
        <span class="img_logo">
          <Logo
            size="40" />
        </span>
        <span class="txt_logo">
          <!-- <span class="txt_service">{{ $commonData.service_name }}</span> -->
          <FirfinLogoText
            height="18"
            :logoColor="isDarkMode ? '#fff' : '#232323'" />
          <span class="txt_admin">{{ $commonData.admin_name | wordToCamal(' ',' ',0) }}</span>
        </span>
      </router-link>
    </h1>
    <div class="service_lemontree">
      <button class="btn_service" @click="onClickLogout()"><span class="icon_logout">👋 </span>Logout</button>
    </div>
  </div>
</template>

<script>
import Logo from '@/components/common/icon/Logo.vue';
import FirfinLogoText from '@lemontree-ai/lemontree-admin-common-front/components/common/icon/FirfinLogoText.vue';
import LocalStorageManager from '@/storages/LocalStorageManager'
import {POST_REQUEST} from '@/services/http';
import { mapGetters } from 'vuex';
import MediaQueryMixin from '@/adminPackage/mixins/MediaQueryMixin';

export default{
  name:'Header',
  mixins: [MediaQueryMixin],
  components:{
    Logo,
    FirfinLogoText
  },
  computed:{
    ...mapGetters('commonGnb', [ 'getIsActiveGnb' ]),
    cssProps(){
      let rObj = {
        '--serviceLetterSpacing': this.$commonData.name_letter_spacing.header.service,
        '--adminLetterSpacing': this.$commonData.name_letter_spacing.header.admin,
      }
      return rObj
    }
  },
  methods:{
    onClickLogout(){
      this.getLogout();
    },
    getLogout(){
      const path = `${this.$apiPath.LOGOUT}`;
      POST_REQUEST(path).then((success) => {
        this.$store.dispatch('commonToast/fetchToastStart', '로그아웃되었습니다');
        this.$router.push({ name : "LoginDirect" }).catch(()=>{});
        LocalStorageManager.shared.clearToken();
        LocalStorageManager.shared.clearUserData();
        this.$store.dispatch('commonUserData/fetchUserData', {});
      }, (failed) => {
        this.$store.dispatch('commonToast/fetchToastStart', failed.msg);
        this.$router.push({ name : "LoginDirect" }).catch(()=>{});
        LocalStorageManager.shared.clearToken();
        LocalStorageManager.shared.clearUserData();
        this.$store.dispatch('commonUserData/fetchUserData', {});
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.head_lemontree{overflow:hidden;position:fixed;top:0;left:0;right:0;z-index:100;border-bottom:1px solid $DEFAULT_BORDER;background-color:$ACTIVE_BG}
.link_logo{display:block}
.btn_snb{float:left;padding:17px 15px 13px;border-right:1px solid $DEFAULT_BORDER;background-color:$ACTIVE_BG;transition:background-color 0.2s}
.btn_snb.acitve{background-color:$PRIMARY_COLOR;border:0 none}
/* hamer 아이콘 */
.icon_hamber{position:relative;display:block;width:20px;height:20px;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: .2s ease-in-out;
  -moz-transition: .2s ease-in-out;
  -o-transition: .2s ease-in-out;
  transition: .2s ease-in-out
}
.icon_hamber span{display:block;position:absolute;height:2px;width:100%;background-color:$PRIMARY_COLOR;border-radius:2px;opacity:1;left:0;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: .25s ease-in-out;
  -moz-transition: .25s ease-in-out;
  -o-transition: .25s ease-in-out;
  transition: .25s ease-in-out;
}
.icon_hamber span:nth-child(1){top:0px}
.icon_hamber span:nth-child(2),
.icon_hamber span:nth-child(3){top:7px}
.icon_hamber span:nth-child(4){top:14px}
/* hamber 아이콘 - 활성화 */
.btn_snb.acitve .icon_hamber span{background-color:#fff}
.btn_snb.acitve .icon_hamber span:nth-child(1){top:7px;width:0%;left:50%}
.btn_snb.acitve .icon_hamber span:nth-child(2){
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  transform: rotate(45deg)
}
.btn_snb.acitve .icon_hamber span:nth-child(3){
  -webkit-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
  -o-transform: rotate(-45deg);
  transform: rotate(-45deg)
}
.btn_snb.acitve .icon_hamber span:nth-child(4){top:7px;width:0%;left:50%}

/* logo */
.head_lemontree .tit_logo{float:left;line-height:26px;}
.head_lemontree .tit_logo .img_logo{display:inline-block;margin:5px 0 5px 16px;vertical-align:top}
.head_lemontree .tit_logo .txt_logo{display:inline-block;margin:8px 0 6px 16px;color:$TITLE_TEXT}
.head_lemontree .tit_logo .txt_service{display:block;font-weight:700;font-size:16px;line-height:18px;letter-spacing:var(--serviceLetterSpacing)}
.head_lemontree .tit_logo .txt_admin{display:block;margin-top:4px;font-weight:500;font-size:12px;line-height:14px;letter-spacing:var(--adminLetterSpacing)}

.service_lemontree{float:right;padding:5px 8px}
.service_lemontree .btn_service{display:inline-block;padding:8px;font-weight:500;line-height:24px;vertical-align:top;color:$CONTENT_TEXT}
.service_lemontree .btn_service .icon_logout{display:inline-block;margin-right:4px;font-size:12px;line-height:24px;vertical-align:top}

/* 모바일 */
// @media all and (max-width:1240px){
//   .service_lemontree .btn_service{font-size:0;}
// }

@media (prefers-color-scheme: dark) {
  .btn_snb{border-color:$DEFAULT_BORDER_DARK;background-color:$ACTIVE_BG_DARK}
  .head_lemontree{border-color:$DEFAULT_BORDER_DARK;background-color:$ACTIVE_BG_DARK}
  .head_lemontree .tit_logo .txt_logo{color:$TITLE_TEXT_DARK}
  .service_lemontree .btn_service{color:$CONTENT_TEXT_DARK}
}
</style>